import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../../store';
import useStyles from './styles';
import { wakeupDevicesV2Action } from '../../../store/commands/general-commands/actions';

const WakeUp = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { client } = useSelector((state: AppState) => state.login);
  const clientAuth: any = client?.authenticate();
  const userName = clientAuth.loginId;
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);

  const [showWakeUpButton, setShowWakeUpButton] = useState<boolean>(true);
  const [showTetheredWakeUp, setShowTetheredWakeUp] = useState<boolean>(false);
  const [wakeupType, setWakeupType] = useState<string>('all');
  const invalidCommercialTypes = new Set(['PL131', 'PL141']);
  const commercialType = selectedEntity?.commercialType ? selectedEntity.commercialType : '';
  const [showMachineWakeUp, setShowMachineWakeUp] = useState<boolean>(false);
  const remoteWakeUpCommercialType = new Set(['PL243']);

  useEffect(() => {
    if (
      (selectedEntity?.isTethered && selectedEntity?.communicationMethod === 'Satellite') ||
      invalidCommercialTypes.has(commercialType)
    ) {
      setShowWakeUpButton(false);
      setShowMachineWakeUp(false);
    } else if (remoteWakeUpCommercialType.has(commercialType) &&
      selectedEntity?.isTethered && selectedEntity?.communicationMethod === 'Cellular' &&
      selectedEntity?.deviceSerialNumber?.endsWith('0079')
    ) {
      setShowMachineWakeUp(true);
      setShowTetheredWakeUp(true);
      setShowWakeUpButton(true);
      setWakeupType('tetheredRadio');
    } else if (selectedEntity?.isTethered && selectedEntity?.communicationMethod === 'Cellular') {
      setShowTetheredWakeUp(true);
      setShowMachineWakeUp(false);
      setShowWakeUpButton(true);
      setWakeupType('tetheredRadio');
    } else {
      setShowWakeUpButton(true);
      setShowTetheredWakeUp(false);
      setShowMachineWakeUp(false);
      setWakeupType('all');
    }
  }, [selectedEntity]);

  const onClickAction = async ({
    carrier,
    wakeupType,
  }: {
    wakeupType: string | undefined;
    carrier?: 'ALL' | 'cdma' | 'gsm' | 'lte' | 'atnt';
  }) => {
    const autoCarrier = 'ALL';
    if (selectedEntity?.deviceId) {
      dispatch(
        wakeupDevicesV2Action({
          devices: [
            {
              deviceId: selectedEntity?.deviceId,
              deviceType: selectedEntity?.deviceType,
            },
          ],
          wakeupType,
          carrier: carrier || autoCarrier,
          userId: userName,
          applicationId: 'iot-gateway',
        }),
      );
    }
  };

  const handleConfirm = () => {
    onClickAction({ wakeupType });
  };

  const handleMachineWakeUp = () => {
    onClickAction({ wakeupType: 'remoteWakeup' });
  };

  return (
    <Box m={2} display="flex" alignItems="center">
      <Box py={0.5}>
        {showWakeUpButton && (
          <Button
            className={classes.button}
            variant="outlined"
            color="primary"
            onClick={() => handleConfirm()}
          >
            {showTetheredWakeUp ? 'Tethered Radio Wake Up' : 'Wake Up'}
          </Button>
        )}
        {showMachineWakeUp && (
          <Button
            className={classes.button}
            variant="outlined"
            color="primary"
            onClick={() => handleMachineWakeUp()}
          >
            Machine Wake Up
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default WakeUp;
